<div class="custom-outcome" *ngIf="!disableComponent && isCustomOutcomeAttributesComponentVisible">
    <app-loader [isLoading]="!settingsLoaded" [loaderHeight]="'200'">
        <form class="custom-outcome__form" [formGroup]="form">
            <div class="custom-outcome__input custom-outcome__input--custom-outcome" *ngIf="settings?.variantSelector?.display">
                <label [for]="settings?.variantSelector?.name" class="custom-outcome__dropdown_label">
                    {{ settings?.variantSelector?.label }}
                    <app-info-tooltip
                        placement="top"
                        iconPath="/assets/shared/svg/info-outline.svg"
                        [text]="settings?.variantSelector?.description"
                    >
                    </app-info-tooltip>
                </label>

                <select class="form-control custom-outcome__dropdown" [id]="settings?.variantSelector?.name" [formControlName]="settings?.variantSelector?.name">
                    <option *ngFor="let val of settings.variantSelector.values" [value]="val">
                        {{ val }}
                    </option>
                </select>
            </div>

            <p class="custom-outcome__section-title" *ngIf="settingsLoaded && selectedVariant">
                Attributes
            </p>

            <div *ngIf="selectedVariant && settingsLoaded">
                <div *ngFor="let attr of selectedVariant.attributes" class="form-group custom-outcome__input-row">
                    <label [for]="attr.name" class="custom-outcome__input-label">
                        {{ attr.label }}
                        <app-info-tooltip
                            placement="top"
                            iconPath="/assets/shared/svg/info-outline.svg"
                            [text]="attr.description"
                        >
                        </app-info-tooltip>
                    </label>

                    <div class="custom-outcome__input-wrapper">
                        <input
                            [id]="attr.name"
                            [type]="attr.type === 'int' ? 'number' : 'text'"
                            [formControlName]="attr.name"
                            [attr.min]="attr.min || null"
                            [attr.max]="attr.max || null"
                            [required]="attr.required"
                            class="form-control custom-outcome__input-field"
                            [placeholder]="attr.description"
                        />

                        <div
                            class="custom-outcome__error"
                            *ngIf="form.get(attr.name)?.invalid && form.get(attr.name)?.touched"
                        >
                            <small *ngIf="form.get(attr.name)?.errors?.['required']">
                                This field is required.
                            </small>
                            <small *ngIf="form.get(attr.name)?.errors?.['min'] || form.get(attr.name)?.errors?.['max']">
                                Value must be between {{ attr.min }} and {{ attr.max }}.
                            </small>
                            <small *ngIf="form.get(attr.name)?.errors?.['pattern'] && attr.type === 'int'">
                                Only numeric values are allowed.
                            </small>
                            <small *ngIf="form.get(attr.name)?.errors?.['pattern'] && attr.type === 'uuid'">
                                Value must be a valid UUID (e.g. 123e4567-e89b-12d3-a456-426614174000).
                            </small>
                            <small *ngIf="form.get(attr.name)?.errors?.['pattern'] && attr.type === 'date'">
                                Value must be a valid date.
                            </small>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </app-loader>
</div>

